module.exports = __webpack_public_path__ + "img/rules_ja.cb60be9c.png";